module.exports = __webpack_public_path__ + "img/eye.b12206c1.svg";